<template>
    <StandardPage :model="model"/>
</template>

<script>
import StandardPage from '@/Scripts/components/pages/StandardPage.vue';

export default {
    props: ['model'],
    components: {
        StandardPage
    }
};
</script>
